import React, { useState, useEffect } from "react";
import { Kbd } from "../ui/caliper";

/* 28px footer strip — live clock + keyboard hints, Caliper style. */
const StatusBar = () => {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const time = now.toLocaleTimeString("en-GB", { hour12: false });
  const date = now.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  return (
    <footer
      className="shrink-0 hidden sm:flex items-center justify-between px-4 bg-surface-subtle border-t border-hairline font-mono text-[11px] text-fg-muted"
      style={{ height: "var(--statusbar-h)" }}
    >
      <div className="flex items-center gap-3.5">
        <span className="flex items-center gap-1.5">
          <span className="w-1.5 h-1.5 rounded-full bg-green-500" />
          Live
        </span>
        <span className="text-fg-subtle">·</span>
        <span>{date}</span>
        <span className="font-semibold text-fg-default">{time} IST</span>
      </div>
      <div className="hidden md:flex items-center gap-3">
        <span className="flex items-center gap-1.5">
          <Kbd>O</Kbd> orders
        </span>
        <span className="flex items-center gap-1.5">
          <Kbd>R</Kbd> reports
        </span>
        <span className="flex items-center gap-1.5">
          <Kbd>⌘K</Kbd> search
        </span>
      </div>
    </footer>
  );
};

export default StatusBar;
